import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  farmer: {},
  web: {},
  mobile: {},
  warehouse: {},
  crop: {},
  variety: {},
  grade: {},
  category: {},
  product: {},
  roles: {},
  city: {},
  country: {},
  state: {},
  district: {},
  procLimitApproval: {},
  procPaymentApproval: {},
  procPaymentCbzFbc: {},
  procPaymentEcocash: {},
  procPaymentCash: {},
  procReconcileCbzFbc: {},
  procReconcileEcocash: {},
  vendorProcessFee: {},
  farmerReconcile: {},
  procReport: {},
  procLimitApprovalReport: {},
  procPaymentApprovalReport: {},
  procPaymentReport: {},
  procPayStatusReport: {},
  procReconcileReport: {},
  vendorPaymentReport: {},
  vendorProcessFeeReport: {},
  procPaySuccessReport: {},
  foProcReport: {},
  intFundTransReport: {},
  logRequestResponseReport: {},
  vendorRemittance: {},
  vendorRemittanceReport: {},
  voucherReport: {},
  voucherApprovalReport: {},
  voucherAuthenticateReport: {},
  voucherApproval: {},
  voucherAuthenticate: {},
  stockReport: {},
  stockEntryReport: {},
  stockDistributionReport: {},
  stopOrderPush: {},
  stopOrderPushReport: {},
  farmVisitReport: {},
  document: {},
  farm: {},
  farmCrop: {},
  procAccountAuditApproval: {},
  procAccountAuditApprovalReport: {},
  ledgerEntReport: {},

  // filter options
  depotList: null,
  vendorList: null,
  loanVendorList: null,
  cropList: null,
  varietyList: null,
  categoryList: null,
  seasonList: null,
};

export const filterSlice = createSlice({
  name: "filterSlice",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      const {
        payload: { type, filters },
      } = action;
      state[type] = filters;
    },
    resetFilters: () => {
      return initialState;
    },
    setDepotList: (state, action) => {
      const { payload } = action;
      state.depotList = payload;
    },
    setCategoryList: (state, action) => {
      const { payload } = action;
      state.categoryList = payload;
    },
    setCropList: (state, action) => {
      const { payload } = action;
      state.cropList = payload;
    },
    setVendorList: (state, action) => {
      const { payload } = action;
      state.vendorList = payload;
    },
    setLoanVendorList: (state, action) => {
      const { payload } = action;
      state.loanVendorList = payload;
    },
    setVarietyList: (state, action) => {
      const { payload } = action;
      state.varietyList = payload;
    },
    setSeasonList: (state, action) => {
      const { payload } = action;
      state.seasonList = payload;
    },
  },
});

export const {
  setFilters,
  resetFilters,
  setDepotList,
  setCategoryList,
  setCropList,
  setVendorList,
  setLoanVendorList,
  setVarietyList,
  setSeasonList,
} = filterSlice.actions;

export default filterSlice.reducer;
